export const metric = (type, ...rest) => {
  window.ym(process.env.REACT_APP_YM, type, ...rest);
};
